<div class="flex items-center justify-center min-h-screen p-3 sm:p-6 bg-gray-100">
  <div class="w-full max-w-3xl bg-brand-surface-card rounded-2xl shadow-2xl border border-brand-subtle overflow-hidden">
    <!-- Header de marca Apolo -->
    <div class="relative px-6 py-6 sm:px-8 bg-[linear-gradient(120deg,_#16173A_0%,_#3366FF_100%)]">
      <div class="absolute inset-0 pointer-events-none opacity-25" style="background: radial-gradient(circle at 88% -30%, #ffffff66, transparent 55%);"></div>
      <div class="relative flex items-center gap-4">
        <img src="/assets/icons/Apolo.svg" alt="Apolo" class="h-9 sm:h-10 w-auto filter brightness-0 invert" />
        <div>
          <h2 class="text-2xl lg:text-3xl font-bold text-white leading-tight">{{ 'AUTH.REGISTER.TITLE' | translate }}</h2>
          <p class="text-sm text-white/80 mt-1">{{ 'AUTH.REGISTER.SUBTITLE' | translate }}</p>
        </div>
      </div>
    </div>

    <div class="p-5 sm:p-6 lg:p-7">
    <div class="space-y-6">
      <div class="relative">
        <div class="absolute top-4 left-1 right-1 h-[2px] bg-gray-200"></div>
        <div
          class="absolute top-4 left-1 h-[2px] bg-brand-accent transition-all duration-300"
          [style.width.%]="(currentStep / (steps.length - 1)) * 100"
        ></div>
        <div class="flex justify-between relative z-10">
          <div *ngFor="let stepDef of steps; let idx = index" class="flex flex-col items-center text-center w-full">
            <div
              class="h-9 w-9 rounded-full flex items-center justify-center text-xs font-semibold border transition-all duration-200"
              [ngClass]="{
                'bg-brand-accent text-white border-brand-accent shadow-lg shadow-blue-200': idx === currentStep,
                'bg-blue-50 text-brand-accent border-brand-subtle': idx < currentStep,
                'bg-gray-100 text-gray-500 border-gray-200': idx > currentStep
              }"
            >
              {{ idx + 1 }}
            </div>
            <p class="mt-1 text-[11px] font-semibold" [ngClass]="idx === currentStep ? 'text-brand-accent' : 'text-gray-700'">
              {{ stepDef.title }}
            </p>
            <p class="text-[10px] text-gray-500">{{ stepDef.description }}</p>
          </div>
        </div>
      </div>

      <form [formGroup]="registerForm" (ngSubmit)="onSubmit()" class="space-y-6">
        <div *ngIf="step.key === 'user'" class="space-y-4" [formGroup]="userGroup">
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label class="block text-sm font-semibold text-gray-700 mb-2 required-marker">Nombre</label>
              <input
                type="text"
                formControlName="firstName"
                placeholder="Ingresa tu nombre"
                class="w-full px-3 py-2.5 rounded-lg border border-gray-200 focus:ring-2 focus:ring-brand-accent focus:border-brand-accent"
              />
              <p *ngIf="hasError('user.firstName','required')" class="text-xs text-red-600 mt-1">El nombre es obligatorio.</p>
              <p *ngIf="hasError('user.firstName','pattern')" class="text-xs text-red-600 mt-1">Solo letras (3 a 40 caracteres).</p>
            </div>
            <div>
              <label class="block text-sm font-semibold text-gray-700 mb-2 required-marker">Apellidos</label>
              <input
                type="text"
                formControlName="lastName"
                placeholder="Ingresa tus apellidos"
                class="w-full px-3 py-2.5 rounded-lg border border-gray-200 focus:ring-2 focus:ring-brand-accent focus:border-brand-accent"
              />
              <p *ngIf="hasError('user.lastName','required')" class="text-xs text-red-600 mt-1">Los apellidos son obligatorios.</p>
              <p *ngIf="hasError('user.lastName','pattern')" class="text-xs text-red-600 mt-1">Solo letras (3 a 40 caracteres).</p>
            </div>
          </div>

          <div>
            <label class="block text-sm font-semibold text-gray-700 mb-2 required-marker">Correo electronico</label>
            <div class="relative">
              <div class="absolute inset-y-0 left-0 flex items-center pl-4 pointer-events-none text-gray-400">
                <svg class="h-5 w-5" fill="currentColor" viewBox="0 0 20 20"><path d="M2 5a2 2 0 012-2h12a2 2 0 012 2v.217l-8 4.8-8-4.8V5z" /><path d="M2 7.383l8 4.8 8-4.8V15a2 2 0 01-2 2H4a2 2 0 01-2-2V7.383z" /></svg>
              </div>
              <input
                type="email"
                formControlName="email"
                placeholder="Ingresa tu correo corporativo"
                class="w-full pl-12 pr-3 py-2.5 rounded-lg border border-gray-200 focus:ring-2 focus:ring-brand-accent focus:border-brand-accent"
              />
            </div>
            <p *ngIf="hasError('user.email','email')" class="text-xs text-red-600 mt-1">Correo inválido.</p>
            <p *ngIf="hasError('user.email','required')" class="text-xs text-red-600 mt-1">El correo es obligatorio.</p>
          </div>

          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label class="block text-sm font-semibold text-gray-700 mb-2 required-marker">Indicativo de país</label>
              <select
                formControlName="phoneDialCode"
                class="w-full px-3 py-2.5 rounded-lg border border-gray-200 focus:ring-2 focus:ring-brand-accent focus:border-brand-accent bg-white"
              >
                <option *ngFor="let option of phoneDialCodes" [value]="option.dialCode">
                  {{ option.dialCode }} - {{ option.label }}
                </option>
              </select>
              <p *ngIf="hasError('user.phoneDialCode','required')" class="text-xs text-red-600 mt-1">El indicativo es obligatorio.</p>
              <p *ngIf="hasError('user.phoneDialCode','pattern')" class="text-xs text-red-600 mt-1">Formato inválido. Ej: +57.</p>
            </div>
            <div>
              <label class="block text-sm font-semibold text-gray-700 mb-2 required-marker">Teléfono</label>
              <input
                type="tel"
                formControlName="phone"
                placeholder="Ingresa tu teléfono"
                class="w-full px-3 py-2.5 rounded-lg border border-gray-200 focus:ring-2 focus:ring-brand-accent focus:border-brand-accent"
              />
              <p *ngIf="hasError('user.phone','required')" class="text-xs text-red-600 mt-1">El teléfono es obligatorio.</p>
              <p *ngIf="hasError('user.phone','pattern')" class="text-xs text-red-600 mt-1">Solo números (7 a 14 dígitos).</p>
            </div>
          </div>

          <div>
            <label class="block text-sm font-semibold text-gray-700 mb-2 required-marker">Contraseña</label>
            <div class="relative">
              <input
                [type]="showPassword ? 'text' : 'password'"
                formControlName="password"
                placeholder="Ingresa tu contraseña"
                class="w-full px-3 py-2.5 rounded-lg border border-gray-200 focus:ring-2 focus:ring-brand-accent focus:border-brand-accent"
              />
              <button
                type="button"
                (click)="togglePassword()"
                class="absolute inset-y-0 right-3 flex items-center text-gray-400 hover:text-brand-accent"
              >
                <svg class="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <ng-container *ngIf="showPassword; else registerEyeClosed">
                    <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" />
                    <circle cx="12" cy="12" r="3" />
                  </ng-container>
                  <ng-template #registerEyeClosed>
                    <path d="M9.88 9.88a3 3 0 1 0 4.24 4.24" />
                    <path d="M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68" />
                    <path d="M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61" />
                    <line x1="2" x2="22" y1="2" y2="22" />
                  </ng-template>
                </svg>
              </button>
            </div>
            <div class="mt-2 rounded-lg border border-brand-subtle bg-blue-50 px-3 py-2 text-xs text-brand-accent">
              Tu contraseña debe incluir:
              <ul class="list-disc pl-5 mt-1 space-y-0.5">
                <li>Mínimo 8 caracteres.</li>
                <li>Al menos una letra mayúscula.</li>
                <li>Al menos una letra minúscula.</li>
                <li>Al menos un número.</li>
                <li>Al menos un símbolo.</li>
              </ul>
            </div>
            <p *ngIf="hasError('user.password','required')" class="text-xs text-red-600 mt-1">La contraseña es obligatoria.</p>
            <p *ngIf="hasError('user.password','pattern')" class="text-xs text-red-600 mt-1">
              Mínimo 8 caracteres, con mayúscula, minúscula, número y símbolo.
            </p>
          </div>

          <div>
            <label class="block text-sm font-semibold text-gray-700 mb-2 required-marker">Confirmar contraseña</label>
            <div class="relative">
              <input
                [type]="showConfirmPassword ? 'text' : 'password'"
                formControlName="confirmPassword"
                placeholder="Repite tu contraseña"
                class="w-full px-3 py-2.5 rounded-lg border border-gray-200 focus:ring-2 focus:ring-brand-accent focus:border-brand-accent"
              />
              <button
                type="button"
                (click)="toggleConfirmPassword()"
                class="absolute inset-y-0 right-3 flex items-center text-gray-400 hover:text-brand-accent"
              >
                <svg class="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <ng-container *ngIf="showConfirmPassword; else confirmEyeClosed">
                    <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" />
                    <circle cx="12" cy="12" r="3" />
                  </ng-container>
                  <ng-template #confirmEyeClosed>
                    <path d="M9.88 9.88a3 3 0 1 0 4.24 4.24" />
                    <path d="M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68" />
                    <path d="M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61" />
                    <line x1="2" x2="22" y1="2" y2="22" />
                  </ng-template>
                </svg>
              </button>
            </div>
            <p *ngIf="hasError('user.confirmPassword','required')" class="text-xs text-red-600 mt-1">
              Debes confirmar la contraseña.
            </p>
            <p *ngIf="hasPasswordMismatch()" class="text-xs text-red-600 mt-1">
              Las contraseñas no coinciden.
            </p>
          </div>
        </div>

        <div *ngIf="step.key === 'company'" class="space-y-4" [formGroup]="companyGroup">
          <div>
            <label class="block text-sm font-semibold text-gray-700 mb-2 required-marker">Nombre o Razón Social</label>
            <input
              type="text"
              formControlName="businessName"
              placeholder="Ingresa nombre o razón social"
              class="w-full px-3 py-2.5 rounded-lg border border-gray-200 focus:ring-2 focus:ring-brand-accent focus:border-brand-accent"
            />
            <p *ngIf="hasError('company.businessName','required')" class="text-xs text-red-600 mt-1">Requerido.</p>
            <p *ngIf="hasError('company.businessName','pattern')" class="text-xs text-red-600 mt-1">Debe tener entre 3 y 120 caracteres.</p>
          </div>

          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label class="block text-sm font-semibold text-gray-700 mb-2">Subdominio (opcional)</label>
              <input
                type="text"
                formControlName="subdomain"
                placeholder="Ej: apolo"
                class="w-full px-3 py-2.5 rounded-lg border border-gray-200 focus:ring-2 focus:ring-brand-accent focus:border-brand-accent"
              />
              <p *ngIf="hasError('company.subdomain','pattern')" class="text-xs text-red-600 mt-1">Usa entre 3 y 63 caracteres: minúsculas, números o guion medio.</p>
            </div>
            <div>
              <label class="block text-sm font-semibold text-gray-700 mb-2">Sitio web</label>
              <input
                type="text"
                formControlName="website"
                placeholder="https://minegocio.com"
                class="w-full px-3 py-2.5 rounded-lg border border-gray-200 focus:ring-2 focus:ring-brand-accent focus:border-brand-accent"
              />
              <p *ngIf="hasError('company.website','pattern')" class="text-xs text-red-600 mt-1">Ingresa una URL o dominio válido.</p>
            </div>
          </div>

          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label class="block text-sm font-semibold text-gray-700 mb-2 required-marker">Industria</label>
              <select
                formControlName="industry"
                class="w-full px-3 py-2.5 rounded-lg border border-gray-200 focus:ring-2 focus:ring-brand-accent focus:border-brand-accent"
              >
                <option value="" disabled>Selecciona industria</option>
                <option *ngFor="let industry of industries" [value]="industry">{{ industry }}</option>
              </select>
              <p *ngIf="hasError('company.industry','required')" class="text-xs text-red-600 mt-1">Selecciona una industria.</p>
            </div>
            <div>
              <label class="block text-sm font-semibold text-gray-700 mb-2 required-marker">Tamaño del equipo</label>
              <input
                type="number"
                min="1"
                formControlName="size"
                class="w-full px-3 py-2.5 rounded-lg border border-gray-200 focus:ring-2 focus:ring-brand-accent focus:border-brand-accent"
              />
              <p *ngIf="hasError('company.size','required')" class="text-xs text-red-600 mt-1">Requerido.</p>
            </div>
          </div>

          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label class="block text-sm font-semibold text-gray-700 mb-2 required-marker">País</label>
              <select
                formControlName="country"
                class="w-full px-3 py-2.5 rounded-lg border border-gray-200 focus:ring-2 focus:ring-brand-accent focus:border-brand-accent"
              >
                <option *ngFor="let country of countries" [value]="country.code">{{ country.label }}</option>
              </select>
              <p *ngIf="hasError('company.country','required')" class="text-xs text-red-600 mt-1">Selecciona un país.</p>
            </div>
            <div>
              <label class="block text-sm font-semibold text-gray-700 mb-2 required-marker">Ciudad</label>
              <select
                formControlName="city"
                class="w-full px-3 py-2.5 rounded-lg border border-gray-200 focus:ring-2 focus:ring-brand-accent focus:border-brand-accent bg-white"
              >
                <option value="" disabled>Selecciona la ciudad</option>
                <option *ngFor="let city of colombiaCities" [value]="city">{{ city }}</option>
              </select>
              <p *ngIf="hasError('company.city','required')" class="text-xs text-red-600 mt-1">Requerido.</p>
              <p *ngIf="hasError('company.city','pattern')" class="text-xs text-red-600 mt-1">Solo letras y nombres de ciudad válidos.</p>
            </div>
          </div>

          <div>
            <label class="block text-sm font-semibold text-gray-700 mb-2 required-marker">Correo de facturación</label>
            <label class="inline-flex items-center gap-2 mb-3 cursor-pointer">
              <input type="checkbox" formControlName="useSameBillingEmail" />
              <span class="text-sm text-gray-700">Usar el mismo correo electrónico</span>
            </label>
            <input
              type="email"
              formControlName="billingEmail"
              placeholder="Ingresa el correo de facturación"
              class="w-full px-3 py-2.5 rounded-lg border border-gray-200 focus:ring-2 focus:ring-brand-accent focus:border-brand-accent disabled:bg-gray-50 disabled:text-gray-500"
            />
            <p *ngIf="hasError('company.billingEmail','required')" class="text-xs text-red-600 mt-1">Requerido.</p>
            <p *ngIf="hasError('company.billingEmail','email')" class="text-xs text-red-600 mt-1">Correo inválido.</p>
          </div>

          <div>
            <label class="block text-sm font-semibold text-gray-700 mb-2 required-marker">¿Qué harás con Signly?</label>
            <select
              formControlName="about"
              class="w-full px-3 py-2.5 rounded-lg border border-gray-200 focus:ring-2 focus:ring-brand-accent focus:border-brand-accent"
            >
              <option value="" disabled>Selecciona una opción</option>
              <option *ngFor="let action of signlyActions" [value]="action">{{ action }}</option>
            </select>
            <p *ngIf="hasError('company.about','required')" class="text-xs text-red-600 mt-1">Selecciona una opción.</p>
          </div>

          <div *ngIf="isOtherSignlyActionSelected">
            <label class="block text-sm font-semibold text-gray-700 mb-2 required-marker">Cuéntanos qué harás</label>
            <input
              type="text"
              formControlName="aboutOther"
              placeholder="Ingresa qué harás con Signly"
              class="w-full px-3 py-2.5 rounded-lg border border-gray-200 focus:ring-2 focus:ring-brand-accent focus:border-brand-accent"
            />
            <p *ngIf="hasError('company.aboutOther','required')" class="text-xs text-red-600 mt-1">Este campo es obligatorio.</p>
            <p *ngIf="hasError('company.aboutOther','minlength')" class="text-xs text-red-600 mt-1">Debe tener al menos 3 caracteres.</p>
          </div>
        </div>

        <div *ngIf="step.key === 'security'" class="space-y-4" [formGroup]="securityGroup">
          <div class="rounded-2xl border border-gray-200 p-5 bg-blue-50">
            <h4 class="text-sm font-semibold text-brand-ink mb-2">Validación de seguridad</h4>
            <p class="text-sm text-brand-accent">Protegemos este registro con validación anti-bot y control de consentimientos.</p>
          </div>

          <div class="rounded-2xl border border-gray-200 p-5 bg-white shadow-sm">
            <h4 class="text-sm font-semibold text-gray-800 mb-3">Revisión rápida de tu información</h4>
            <div class="space-y-3 text-sm text-gray-700">
              <div class="flex items-center gap-2">
                <span class="h-2 w-2 rounded-full bg-green-500"></span>
                <span><strong>Nombre:</strong> {{ userGroup.get('firstName')?.value || 'Nombre' }} {{ userGroup.get('lastName')?.value || '' }}</span>
              </div>
              <div class="flex items-center gap-2">
                <span class="h-2 w-2 rounded-full bg-green-500"></span>
                <span><strong>Correo electrónico:</strong> {{ userGroup.get('email')?.value || 'correo@negocio.com' }}</span>
              </div>
              <div class="flex items-center gap-2">
                <span class="h-2 w-2 rounded-full bg-green-500"></span>
                <span><strong>Correo de facturación:</strong> {{ companyGroup.get('billingEmail')?.value || 'facturacion@negocio.com' }}</span>
              </div>
              <div class="flex items-center gap-2">
                <span class="h-2 w-2 rounded-full bg-green-500"></span>
                <span><strong>Nombre o Razón Social:</strong> {{ companyGroup.get('businessName')?.value || 'Nombre o razón social' }}</span>
              </div>
              <div class="flex items-center gap-2">
                <span class="h-2 w-2 rounded-full bg-green-500"></span>
                <span><strong>Subdominio:</strong> {{ companyGroup.get('subdomain')?.value || 'subdominio' }}</span>
              </div>
              <div class="flex items-center gap-2">
                <span class="h-2 w-2 rounded-full bg-green-500"></span>
                <span><strong>Ubicación:</strong> {{ companyGroup.get('city')?.value || 'Ciudad' }}, {{ companyGroup.get('country')?.value || 'País' }}</span>
              </div>
              <div class="flex items-center gap-2">
                <span class="h-2 w-2 rounded-full bg-green-500"></span>
                <span><strong>Industria:</strong> {{ companyGroup.get('industry')?.value || 'Industria' }}</span>
              </div>
            </div>
          </div>

          <div class="rounded-2xl border border-gray-200 p-5">
            <h4 class="text-sm font-semibold text-gray-700 mb-3">Código de referido</h4>
            <label class="inline-flex items-center gap-2 mb-3 cursor-pointer">
              <input type="checkbox" formControlName="hasReferralCode" />
              <span class="text-sm text-gray-700">Tengo un código de referido</span>
            </label>
            <input
              *ngIf="hasReferralCodeEnabled"
              type="text"
              formControlName="referralCode"
              placeholder="Ingresa tu código de referido"
              class="w-full px-3 py-2.5 rounded-lg border border-gray-200 focus:ring-2 focus:ring-brand-accent focus:border-brand-accent"
            />
            <p *ngIf="hasError('security.referralCode','pattern')" class="text-xs text-red-600 mt-1">Usa 3 a 40 caracteres: letras, números, guion o guion bajo.</p>
          </div>

          <div class="rounded-2xl border border-brand-subtle p-5 bg-brand-surface-card">
            <h4 class="text-sm font-semibold text-brand-ink mb-4">Consentimientos (requeridos)</h4>
            <label class="flex items-start gap-3 cursor-pointer">
              <input type="checkbox" class="mt-1 accent-brand-accent" formControlName="tosAccepted" />
              <span class="text-sm text-gray-700">Acepto los Términos y Condiciones de uso de Signly.</span>
            </label>
            <label class="flex items-start gap-3 cursor-pointer mt-3">
              <input type="checkbox" class="mt-1 accent-brand-accent" formControlName="privacyAccepted" />
              <span class="text-sm text-gray-700">Acepto el aviso de Privacidad y autorizo el tratamiento de mis datos.</span>
            </label>

            <!-- Validez jurídica de la firma electrónica (depende del país) -->
            <label class="mt-4 flex items-start gap-3 cursor-pointer rounded-xl border border-brand-subtle bg-blue-50 p-3">
              <input type="checkbox" class="mt-1 accent-brand-accent" formControlName="electronicValidityAccepted" />
              <span class="text-sm text-gray-700">
                Declaro que conozco y acepto la <strong>validez jurídica de la firma electrónica</strong>,
                con plenos efectos legales y probatorios conforme a {{ electronicValidityRef.law }}.
                Puedes consultar el marco normativo aplicable
                <a
                  [href]="electronicValidityRef.url"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="font-semibold text-brand-accent underline hover:text-brand-accent"
                >aquí</a>.
              </span>
            </label>

            <p
              *ngIf="hasError('security.tosAccepted','required') || hasError('security.privacyAccepted','required') || hasError('security.electronicValidityAccepted','required')"
              class="text-xs text-red-600 mt-3"
            >
              Debes aceptar los Términos, el aviso de Privacidad y la validez de la firma electrónica para continuar.
            </p>
          </div>
        </div>

        <div class="flex flex-col gap-3 pt-3">
          <div class="flex items-center gap-3">
            <button
              type="button"
              (click)="backToLogin()"
              class="px-4 py-2.5 rounded-lg text-white bg-brand-accent hover:bg-brand-accent-hover shadow-md shadow-blue-200 text-sm font-medium"
            >
              Ya tengo cuenta
            </button>

            <button
              *ngIf="currentStep > 0"
              type="button"
              (click)="goPrev()"
              class="px-4 py-2.5 rounded-lg border border-brand-subtle text-brand-accent bg-blue-50 hover:bg-brand-surface-raised text-sm font-medium"
            >
              Atrás
            </button>

            <div class="flex-1"></div>

            <button
              type="submit"
              [disabled]="loading"
              class="px-5 py-2.5 rounded-lg text-white bg-brand-accent hover:bg-brand-accent-hover shadow-md shadow-blue-200 text-sm font-semibold disabled:opacity-60"
            >
              <span *ngIf="!loading && currentStep < steps.length - 1">Siguiente</span>
              <span *ngIf="!loading && currentStep === steps.length - 1">Crear cuenta</span>
              <span *ngIf="loading" class="flex items-center gap-2">
                <span class="h-4 w-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                Procesando...
              </span>
            </button>
          </div>

          <div *ngIf="errorMessage" class="text-red-600 text-sm">{{ errorMessage }}</div>
        </div>
      </form>
    </div>
    </div>
  </div>
</div>
